import { momentumConstants } from '../_constants';

export function listMomentumsReducer(state = {}, action) {
  switch  (action.type) {
    case momentumConstants.LIST_MOMENTUMS_REQUEST:
      return {
        listedMomentums: true
      }
    case momentumConstants.LIST_MOMENTUMS_SUCCESS:
      return {
        listedMomentums: true
      }
    case momentumConstants.LIST_MOMENTUMS_FAILURE:
      return {
        listedMomentums: false
      }
    default:
      return {
        listedMomentums: state
      }
  }
}

export function listFiltersReducer(state = {}, action) {
  switch  (action.type) {
    case momentumConstants.LIST_FILTERS_REQUEST:
      return {
        listedFilters: true
      }
    case momentumConstants.LIST_FILTERS_SUCCESS:
      return {
        listedFilters: true
      }
    case momentumConstants.LIST_FILTERS_FAILURE:
      return {
        listedFilters: false
      }
    default:
      return {
        listedFilters: state
      }
  }
}

export function listChannelsReducer(state = {}, action) {
  switch  (action.type) {
    case momentumConstants.LIST_CHANNELS_REQUEST:
      return {
        listedChannels: true
      }
    case momentumConstants.LIST_CHANNELS_SUCCESS:
      return {
        listedChannels: true
      }
    case momentumConstants.LIST_CHANNELS_FAILURE:
      return {
        listedChannels: false
      }
    default:
      return {
        listedChannels: state
      }
  }
}

export function createMomentumReducer(state = {}, action) {
  switch (action.type) {
    case momentumConstants.CREATE_MOMENTUM_REQUEST:
      return {
        createdMomentum: true
      }
    case momentumConstants.CREATE_MOMENTUM_SUCCESS:
      return {
        createdMomentum: true
      }
    case momentumConstants.CREATE_MOMENTUM_FAILURE:
      return {
        createdMomentum: false
      }
    default:
      return {
        createdMomentum: state
      }
  }
}